export default __webpack_public_path__ + "static/media/delivery.aa381071.webp";